<template>
  <div :style="[!condition?{'opacity': 0.5}:{}]">
    <i class="fas fa-toggle-on clickable" @click="$emit('toggle', false);" style="margin-right: 0.5vw" v-if="condition"></i>
    <i class="fas fa-toggle-off clickable" @click="$emit('toggle', true);" style="margin-right: 0.5vw" v-else></i>
    <slot ></slot>
  </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
name: "toggle",
  model: {
    prop: 'condition',
    event: 'toggle'
  },
  props: {
    condition: Boolean
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
}
</script>

<style scoped>

</style>